function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var appearances = function appearances() {
  return {
    primary: {
      boxShadow: 'normal',
      backgroundColor: 'white',
      borderRadius: 2
    },
    flat: {
      backgroundColor: 'white',
      borderRadius: 2
    },
    raised: {
      boxShadow: 'raised',
      backgroundColor: 'white',
      borderRadius: 2
    }
  };
};

var sizes = function sizes() {
  return {
    small: {
      px: 4,
      py: 4,
      borderRadius: 2
    },
    medium: {
      px: 5,
      py: 5,
      borderRadius: 2
    },
    large: {
      px: 6,
      py: 6,
      borderRadius: 2
    }
  };
};

var types = function types() {
  return {
    interactive: {
      '&:hover': {
        boxShadow: 'raised',
        cursor: 'pointer'
      }
    },
    normal: {}
  };
};

export var _getBaseStyle = function _getBaseStyle(props) {
  return _objectSpread(_objectSpread(_objectSpread({}, appearances(props)[props.appearance]), sizes(props)[props.size]), types(props)[props.type]);
};